









































































import { Component, Mixins, VModel } from 'vue-property-decorator';

import ModelSetter from "../../../../Mixins/ModelSetter";
import ConfigField from "../../../../components/ConfigField/ConfigField.vue";
import UploadArea
  from "../../../../components/NewMessageEditors/NewMessageEditorWithMedia/Media/components/UploadArea.vue";
import EditorInput from '../../../../components/Pi/fields/EditorInput/EditorInput.vue';
import FileInput from "../../../../components/Pi/fields/FileInput/FileInput.vue";
import PiTabs from "../../../../components/PiTabs.vue";
import { SelectOption } from '../../../../logic/types';
import { SendFeedbackData, SendFeedbackTypeEnum } from "../../types/SendFeedback.types";

@Component({
  data() {
    return {
      SendFeedbackTypeEnum
    }
  },
  components: {
    UploadArea,
    FileInput,
    ConfigField,
    PiTabs,
    EditorInput
  }
})
export default class FeedbackForm extends Mixins(ModelSetter) {
  @VModel() form!: SendFeedbackData

  get tabs(): Array<SelectOption> {
    return [
      {
        label: this.$t('feedback_form_error').toString(),
        value: SendFeedbackTypeEnum.Error
      },
      {
        label: this.$t('feedback_form_feedback').toString(),
        value: SendFeedbackTypeEnum.Feedback
      }
    ]
  }

  changeTab(type: SendFeedbackTypeEnum) {
    this.form.type = type

    if (type === SendFeedbackTypeEnum.Error) {
      this.$set(this.form, 'file', null)

      this.$delete(this.form, 'rating')
    } else {
      this.$set(this.form, 'rating', 0)

      this.$delete(this.form, 'file')
    }
  }

  files: null | File = null

  onChange(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { files } = e.target

      if (files && files.length && this.form.type === SendFeedbackTypeEnum.Error) {
        this.form.file = files[0]
      }
    }
  }
}
